import React from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'

import { Button } from '@rewardops/ui'

export enum TranstionBtnDirection {
  Right = 'right',
  Left = 'left',
}

type TransitionBtnProps = {
  onClick: () => void
  direction: TranstionBtnDirection
  ariaLabel: string
}

const TransitionBtn: React.FC<TransitionBtnProps> = ({
  onClick,
  direction,
  ariaLabel,
}: TransitionBtnProps) => {
  return (
    <Button
      className="group h-[62px] w-[62px] rounded-full border border-gray-300 bg-white"
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {direction == TranstionBtnDirection.Left ? (
        <ChevronLeft className="text-black group-hover:text-white" size={24} />
      ) : (
        <ChevronRight className="text-black group-hover:text-white" size={24} />
      )}
    </Button>
  )
}

export { TransitionBtn }
